import Recruiter from 'entities/recruiter'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './introducer_label_card.module.scss'

const IntroducerLabelCard = ({ introducer, show }) => {
  if (!show) {
    return null
  }

  return (
    <div className={styles.card}>
      <div className={styles.introducerName}>{introducer.name}</div>
      <div className={styles.introducerGroup}>{introducer.group.name}</div>
    </div>
  )
}

IntroducerLabelCard.propTypes = {
  introducer: PropTypes.instanceOf(Recruiter).isRequired,
  show: PropTypes.bool.isRequired
}

export default IntroducerLabelCard
